import { lookupsConstant } from "../constants";


let initialState = {
    managerList: [],
    statusList: [],
    usersList: [],
    commentTypes: [],
    departmentList:[],
    teamList:[],
    locationList:[],
    jobTitleList:[],
    empTypeList:[],
    trainingTypeList:[],
    trainingLevelList:[],
    trainingStatus:[],
    empTrainingStatus:[],
    employeeLevel:[],
    yesnoList:[],
    reportingUsers:[],
    error: ""
}

export const loadReportingManagers_Reducer = (state = initialState, action) => {

    switch (action.type) {
        case lookupsConstant.GET_MANAGERS_LOOKUPS_SUCCESS:
            return {
                ...state,
                managerList: action.payload
            }
        case lookupsConstant.GET_MANAGERS_LOOKUPS_FAILURE:
            return {
                ...state,
                error: action.payload
            }

        default:
            return state;
    }
}


export const loadStatus_Reducer = (state = initialState, action) => {

    switch (action.type) {
        case lookupsConstant.GET_STATUS_LOOKUP_SUCCESS:
            return {
                ...state,
                statusList: action.payload
            }
        case lookupsConstant.GET_STATUS_LOOKUP_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state;
    }
}


export const loadUsers_Reducer = (state = initialState, action) => {

    switch (action.type) {
        case lookupsConstant.GET_USERS_LOOKUP_DATA_SUCCESS:
            return {
                ...state,
                usersList: action.payload
            }
        case lookupsConstant.GET_USERS_LOOKUP_DATA_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state;
    }
}

export const loadCommentsTypes_Reducer = (state = initialState, action) => {

    switch (action.type) {
        case lookupsConstant.COMMNETS_TYPES_LOOKUP_DATA_SUCCESS:
            return {
                ...state,
                commentTypes: action.payload
            }
        case lookupsConstant.COMMNETS_TYPES_LOOKUP_DATA_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state;
    }
}

export const loadDepartment_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_DEPARTMENT_LOOKUP_SUCCESS:
            return {
                ...state,
                departmentList: action.payload
            }
        case lookupsConstant.GET_DEPARTMENT_LOOKUP_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}


export const loadTeam_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_TEAM_LOOKUP_SUCCESS:
            return {
                ...state,
                teamList: action.payload
            }
        case lookupsConstant.GET_TEAM_LOOKUP_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadLocation_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_LOCATION_LOOKUP_SUCCESS:
            return {
                ...state,
                locationList: action.payload
            }
        case lookupsConstant.GET_LOCATION_LOOKUP_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadJobTitle_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_JOBTITLE_LOOKUP_SUCCESS:
            return {
                ...state,
                jobTitleList: action.payload
            }
        case lookupsConstant.GET_JOBTITLE_LOOKUP_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadEmpType_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_EMPLOYEETYPE_SUCCESS:
            return {
                ...state,
                empTypeList: action.payload
            }
        case lookupsConstant.GET_EMPLOYEETYPE_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadTrainingType_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_TRAININGTYPE_SUCCESS:
            return {
                ...state,
                trainingTypeList: action.payload
            }
        case lookupsConstant.GET_TRAININGTYPE_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}


export const loadTrainingLevel_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_TRAININGLEVEL_SUCCESS:
            return {
                ...state,
                trainingLevelList: action.payload
            }
        case lookupsConstant.GET_TRAININGLEVEL_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}


export const loadTrainingStatus_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_TRAININGSTATUS_SUCCESS:
            return {
                ...state,
                trainingStatus: action.payload
            }
        case lookupsConstant.GET_TRAININGSTATUS_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}
export const loadEmpTrainingStatus_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_EMP_TRAINING_STATUS_SUCCESS:
            return {
                ...state,
                empTrainingStatus: action.payload
            }
        case lookupsConstant.GET_EMP_TRAINING_STATUS_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadEmployeeLevel_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_EMPLOYEELEVEL_SUCCESS:
            return {
                ...state,
                employeeLevel: action.payload
            }
        case lookupsConstant.GET_EMPLOYEELEVEL_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadYesNo_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_YESNO_SUCCESS:
            return {
                ...state,
                yesnoList: action.payload
            }
        case lookupsConstant.GET_YESNO_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}

export const loadReportingUsers_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case lookupsConstant.GET_ONLY_REPORTING_USERS_SUCCESS:
            return {
                ...state,
                reportingUsers: action.payload
            }
        case lookupsConstant.GET_ONLY_REPORTING_USERS_FAILURE:
            return {
                ...state,
                error:action.payload
            }
        default:
            return state;
    }
}